import Stores       from './stores';
import Models       from './models';
import Logger       from './logger';
import Instance     from './instance';

class Superstore {
    constructor(options) {
        options = options || {};

        var _ = this,
            key;

        _.models = {};
        _.data = {};

        _.logger = options.logger || new Logger({
            debug: options.debug || false,
            prefix: _.constructor.name + ' ~>',
            logger: console
        });

        _.logger.log('initializing');

        for (key in options.models) {
            _.registerModel(key, options.models[key]);
        }

        for (key in options.storage) {
            _.registerStore(key, options.storage[key]);
        }

        _.logger.log('initialized', _);
    }

    registerModel(key, model) {
        var _ = this;
        _.models[key] = model;
        return model._connect(_, key);
    }

    registerStore(key, store) {
        var _ = this;
        _.stores[key] = store;
        return store._connect(_, key);
    }

    toString() {
        var _ = this;
        return JSON.stringify(_);
    }
}

Superstore.Models       = Models;
Superstore.Logger       = Logger;
Superstore.Stores       = Stores;
Superstore.Instance     = Instance;

window.Superstore = Superstore;

export default Superstore;
